export const GET_CATEGORY="getcategory"

export const GET_MENS_DATA_SUCCESS="getmensdata"
export const GET_PAGESUCCESS="page"
export const GET_FILTERED_DATA="filtered"